// extracted by mini-css-extract-plugin
module.exports = {"Button":"SupplierMarketplaceButtons_Button__3pwuQ","Divider":"SupplierMarketplaceButtons_Divider__320Z_"};